import React from "react";
import { GetDateDetails } from "../../../../../utils/GetDateDetails";

export default function ThirdSession({ data }) {
  const date = GetDateDetails(data.datetime);
  const formatTxt = (str) => {
    return str.slice(0, 3);
  };
  return (
    <div>
      <div className="grid grid-cols-5 pt-20 px-[10%]">
        <div className="pr-5 col-span-2">
          <p className="text-black text-right font-bold text-xl leading-tight">
            <span>{date.dayStr}</span>
            <span className=" font-bold pl-1">{formatTxt(date.month)}</span>
          </p>
          <p className="text-black text-right  font-bold text-base">
            {date.year}
          </p>
        </div>
        <div className="flex flex-col gap-20 border-l-2 border-white pl-5 col-span-3">
          <div className="flex flex-col gap-2">
            <p className="text-black font-bold text-2xl">{data.location1.name.toUpperCase()}</p>
            <p className="text-black  text-lg">{date.time}</p>
            <p className="text-black  text-lg">{data.location1.title}</p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={data.location1.link}
              className=" flex justify-start gap-2"
            >
              <img
                src="https://www.freeiconspng.com/thumbs/location-icon-png/google-location-icon-16.png"
                alt="location"
                className="w-4 object-contain"
              />
              <p className="text-black font-semibold">Get Direction</p>
            </a>
          </div>
          {data.addLoc2 && (
            <div className="flex flex-col gap-2">
              <p className="text-black font-bold text-2xl">{data.location2.name.toUpperCase()}</p>
              <p className="text-black text-lg">{data.location2.time}</p>
              <p className="text-black text-lg">{data.location2.title}</p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={data.location2.link}
                className="flex justify-start gap-2"
              >
                <img
                  src="https://www.freeiconspng.com/thumbs/location-icon-png/google-location-icon-16.png"
                  alt="location"
                  className="w-4 object-contain"
                />
                <p className="text-black font-semibold">Get Direction</p>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
